import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
import LayoutMenus from "@/components/Layout/LayoutMenus";
import LayoutBlank from "@/components/Layout/LayoutBlank";
import homepage1 from "../views/homepage1.vue";
import homepage2 from "../views/homepage2.vue";
import homepage3 from "../views/homepage3.vue";
import homepage4 from "../views/homepage4.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LayoutBlank",
    component: LayoutBlank,
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "index",
        component: index,
      },
      {
        path: "/homepage1",
        name: "homepage1",
        component: homepage1,
      },
      {
        path: "/homepage2",
        name: "homepage2",
        component: homepage2,
      },
      {
        path: "/homepage3",
        name: "homepage3",
        component: homepage3,
      },
      {
        path: "/homepage4",
        name: "homepage4",
        component: homepage4,
      },
      {
        path: "/listpage",
        name: "listpage",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "listpage" */ "@/views/listPage/index.vue"
          ),
      },
      {
        path: "/detail",
        name: "detail",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "detail" */ "@/views/detail/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
